import { render, staticRenderFns } from "./UserNameModal.vue?vue&type=template&id=7a510e97&"
import script from "./user-name-modal.ts?vue&type=script&lang=ts&"
export * from "./user-name-modal.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports